import { render, staticRenderFns } from "./SpecimenStatusChangedModal.vue?vue&type=template&id=7c6d59b4"
import script from "./SpecimenStatusChangedModal.vue?vue&type=script&lang=js"
export * from "./SpecimenStatusChangedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports